export async function autoCompleteRequest(google, input){
    return new Promise((resolve, reject) => {
        if(!google){
            return reject(false);
        }

        const service = new google.maps.places.AutocompleteService();
        service.getPlacePredictions({
            input: input,
            types: ['geocode'],
            componentRestrictions: {country: 'fr'}
        }, (predictions, status) => {
            if(status === 'OK'){
                resolve(predictions);
            }
            else{
                reject(status);
            }
        });
    });
}
